export class MathsNaiveStaticV5 {
    public sensor_Y: number[] = [];
    public sensor_X: number[] = [];
}
